<div class="contact-modal" role="dialog" aria-modal="true" >
  <debtor-panel-loading-spinner [isLoading]="store.isLoading()" />
  <div class="modal-header">
    <div class="header-text">
      <h2 tabindex="-1">{{ 'contact-form.title' | translate }}</h2>
      <p>{{ 'contact-form.sub-title' | translate }}</p>
    </div>
    <button
      mat-icon-button
      (click)="onCloseClick()"
      class="close-button"
      [attr.aria-label]="'alt-for-img.close-window' | translate "
    >
      <mat-icon  class="custom-icon" svgIcon="close_custom_icon" ></mat-icon>
    </button>
  </div>

  <form class="form" [formGroup]="contactForm" (ngSubmit)="onSubmit()">
    @if (contactForm.get('topic')?.touched && contactForm.get('topic')?.hasError('required')) {
      <mat-error >
        {{ 'contact-form.field-topic-required' | translate }}
      </mat-error>
    }
    <mat-form-field class="topic-select" appearance="outline" >
      <mat-label >{{ 'contact-form.subject' | translate }}</mat-label>
      <mat-select formControlName="topic"  aria-required="true" required>
        @for (item of store.subjects(); track item.idHash ) {
          <mat-option [value]="item.idHash">{{ item.name }}</mat-option>
        } @empty {
          <mat-option>
            <debtor-panel-loading-spinner-select [isLoading]="store.isLoadingTopics()"/>
            @if(!store.isLoadingTopics() &&  store.subjects().length === 0) {
              {{ 'no-phone-data' | translate }}
            }
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field class="message-field" appearance="outline">
      <textarea
        matInput
        placeholder="{{ 'contact-form.placeholder-text' | translate }}"
        [maxlength]="messageMaxLengthNumber"
        rows="8"
        formControlName="message"
        aria-label="textarea"
      ></textarea>
      <mat-hint align="end">{{contactForm.get('message')?.value?.length || 0}}/{{messageMaxLength}}</mat-hint>
      @if (contactForm.get('message')?.touched && contactForm.get('message')?.hasError('required')) {
        <mat-error>
          {{ 'contact-form.field-message-required' | translate }}
        </mat-error>
      }
    </mat-form-field>

    <div class="d-flex attachment-section">
      <input
        type="file"
        #fileInput
        class="file-input-display"
        (change)="onFileSelected($event)"
        aria-label="file"
      >
      <button
        mat-flat-button
        class="btn-border file-button col col-mobile-12"
        type="button"
        (click)="fileInput.click()"
        aria-label="Add file"
      >
        <mat-icon svgIcon="upload_custom_file"></mat-icon>
        {{ 'contact-form.add-file' | translate }}
      </button>
      <span class="file-size-info col col-mobile-12">{{ 'contact-form.max-file-size-info' | translate: { amount: this.store.maxFileSize() } }}</span>
    </div>

    <div *ngIf="selectedFileName" class="selected-file">
      <span>{{ selectedFileName }}</span>
      <button
        class="remove-file-btn"
        type="button"
        (click)="removeFile()"
        aria-label="Remove file">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <button
      mat-flat-button
      class="btn-common submit-button"
      type="submit"
      [disabled]="contactForm.invalid"
      aria-label="Submit"
    >
    {{ 'contact-form.submit-btn' | translate }}
    </button>
  </form>
</div>